import { setDefaultStyle } from "apparatus/draw";
import { P, Segments } from "apparatus/library/common";
import { CommonCondenser, condenserCaseShape } from "apparatus/library/condensers";
import { Group, Path } from "paper";
export class LiebigCondenser {
    render(appearance) {
        const { ports, height } = appearance;
        const { group: casing, snap: snapping } = condenserCaseShape(height, 15, ports);
        const insideTube1 = new Path(Segments([[-7.5, 0]], [[-7.5, 10]], [[-5, 25]], [[-5, height - 25]], [[-7.5, height - 10]], [[-7.5, height]]));
        const insideTube2 = insideTube1.clone();
        insideTube2.scale(-1.0, 1.0, P(0, 0));
        let graphic = new Group([casing, insideTube1, insideTube2]);
        setDefaultStyle(graphic);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping,
            pivot: P(0, height / 2)
        };
    }
}
LiebigCondenser.properties = {
    label: "Liebig Condenser",
    flippable: true,
    defaultAppearance: Object.assign({}, CommonCondenser.defaultAppearance),
    appearanceSpecs: [
        ...CommonCondenser.appearanceSpecs,
    ],
    isBoostRequired: a => CommonCondenser.isBoostRequired(a)
};
